import React, { Component } from 'react'
import ButtonClose from 'components/ButtonClose/ButtonClose';
import ContinueConversation from 'components/ContinueConversation/ContinueConversation';
import StartConversation from 'components/StartConversation/StartConversation';
import styles from "./BodyHome.module.scss";
import { __callbacks } from "Utils/Callbacks/Callback";
import { AppState } from 'Utils/Enums';
import { __chats } from 'Utils/Chats/Chats';

export default class BodyHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalConversations: 0,
            classHide: this.getClassHide(),
            classHideContinueConvs: this.getClassHideContinueConvs(0),
        };
        this.container = React.createRef();
    }

    componentDidMount() {
        this.initEvents();

        __chats.onTotalConversations((data) => {
            this.setState({
                totalConversations: data.totalConversations,
                classHideContinueConvs: this.getClassHideContinueConvs(data.totalConversations)
            });
        });

        // Check local storage and update classHideContinueConvs
        const missedChats = JSON.parse(localStorage.getItem("chats") || "{}");
        if (Object.keys(missedChats).length > 0) {
            this.setState({
                classHideContinueConvs: ""
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.appState !== prevProps.appState && this.props.appState !== AppState.home) {
            setTimeout(() => {
                this.container.current.scrollTop = 0;
            }, 500);
        }
    }

    getClassHide = () => (this.props.appState !== AppState.home) ? styles["container-hide"] : "";

    getClassHideContinueConvs = (totalConversations) => (totalConversations > 0) ? "" : "hide-hard";

    initEvents = () => {
        this.container.current.addEventListener("scroll", e => {
            __callbacks.homeBodyScroll.trigger({ scrollTop: this.container.current.scrollTop });
        });
    }

    render() {
        return (
            <div ref={this.container} className={`${styles.container} ${this.getClassHide()} container-main-body-items`}>
                <div id="continue-conversations" className={`${styles["container-content-box"]} ${styles["card-item"]} card-item config-containersMetaData ${this.state.classHideContinueConvs}`}>
                    <ContinueConversation></ContinueConversation>
                </div>
                <div className={`${styles["container-content-box"]} ${styles["card-item"]} card-item config-containersMetaData`}>
                    <StartConversation button={true}></StartConversation>
                </div>
                <div className={`${styles["container-btn-close"]}`}>
                    <ButtonClose></ButtonClose>
                </div>
            </div>
        );
    }
}
